import { styled } from "@mui/material";

export const TitleСompetenceContainer = styled("div")(({ theme }) => ({
  width: "100%",
  color: theme.palette.custom.grey.main,
}));
